import { render, staticRenderFns } from "./NewCriterioCard.vue?vue&type=template&id=53037169"
import script from "./NewCriterioCard.vue?vue&type=script&lang=js"
export * from "./NewCriterioCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports